import { rem } from '@app/utils/sx/functions';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const codeInputBox: SxProps<Theme> = {
  display: 'flex',
  m: rem([32, 0]),
  input: {
    width: rem(44),
    height: rem(60),
    mr: { xs: rem(6), md: rem(12) },
    color: 'text.primary',
    fontWeight: 500,
    fontSize: rem(18),
    lineHeight: rem(22),
    textAlign: 'center',
    border: `${rem(1)} solid`,
    borderColor: 'actions.borders',
    borderRadius: rem(6),
    outline: 'none',
    '&:hover': {
      borderColor: 'text.primary',
    },
    '&:last-child': {
      mr: 0,
    },
    '&::-webkit-outer-spin-button': {
      m: 0,
    },
    '&::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '&[type="number"]': {
      MozAppearance: 'textfield',
    },
  },
};
